/** localStorage key — separate from faculty app which uses `token`. */
export const AUTH_TOKEN_KEY = 'students_token';

const LEGACY_TOKEN_KEY = 'token';

export const getStoredToken = () => (
    localStorage.getItem(AUTH_TOKEN_KEY) || localStorage.getItem(LEGACY_TOKEN_KEY)
);

export const setStoredToken = (token) => {
    localStorage.removeItem(LEGACY_TOKEN_KEY);
    localStorage.setItem(AUTH_TOKEN_KEY, token);
};

export const clearStoredAuth = () => {
    localStorage.removeItem(AUTH_TOKEN_KEY);
    localStorage.removeItem(LEGACY_TOKEN_KEY);
    localStorage.removeItem('user');
};
